// utils/listingSession.ts

export const saveListingState = (model: string, state: any) => {
  const key = `listing_state_${model}`;
  sessionStorage.setItem(key, JSON.stringify(state));
};

export const loadListingState = (model: string): any => {
  const key = `listing_state_${model}`;
  const raw = sessionStorage.getItem(key);
  try {
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearListingState = (model: string) => {
  const key = `listing_state_${model}`;
  sessionStorage.removeItem(key);
};
